import { decitraitDateFormat } from '../../../resources/decitrait';
import { useClient } from '../../../ClientProvider';
import useMutation from '../../../useMutation';
import useDecitraitCreateOrUpdatePlot from './useDecitraitCreateOrUpdatePlot';
import useQuery from '../../../useQuery';
import moment from 'moment-timezone';
/** Create a decitrait plot matching the name of a weenat plot, may return null if the decitrait resources is not available */
export const useDecitraitUpdatePlot = ({ plot, onSuccess }) => {
    const client = useClient();
    const decitraitPlotDetailRequester = client.decitrait.plotDetail({ plotId: plot.id });
    const decitraitPlotDetail = useQuery(decitraitPlotDetailRequester).data;
    const [updatePlot, updatePlotRequest] = useMutation(client.decitrait.updatePlot({ plotId: plot.id }), { onSuccess, keysToInvalidate: [decitraitPlotDetailRequester.key] });
    const createOrUpdatePlot = useDecitraitCreateOrUpdatePlot({
        plot,
        defaultValues: decitraitPlotDetail
            ? {
                name: decitraitPlotDetail.name,
                plotArea: decitraitPlotDetail.plotArea,
                trainingMethod: decitraitPlotDetail.trainingMethod,
                interPlant: decitraitPlotDetail.interPlant,
                interRow: decitraitPlotDetail.interRow,
                mildewSensibility: decitraitPlotDetail.mildewSensibility,
                oidiumSensibility: decitraitPlotDetail.oidiumSensibility,
                harvestDate: moment(decitraitPlotDetail.harvestDate, decitraitDateFormat).toDate(),
                hadOidiumAttack: decitraitPlotDetail.hadOidiumAttack === '1' ? false : true
            }
            : undefined,
        mutate: updatePlot,
        request: updatePlotRequest
    });
    if (!createOrUpdatePlot || !decitraitPlotDetail)
        return null;
    const { props } = createOrUpdatePlot;
    return {
        props
    };
};
